import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
import { tokenInfo } from '../lib/token';
import { LAUNCH_DARKLY_CLIENT_ID } from '../common/constants';

const flagCache: { [featureKey: string]: boolean } = {};
let client: LaunchDarkly.LDClient;

export const initializeLD = async () => {
  client = LaunchDarkly.initialize(LAUNCH_DARKLY_CLIENT_ID, {
    key: tokenInfo.AccountId,
  });

  await new Promise((resolve, reject) => {
    client.on('ready', () => {
      resolve();
    });
  });
};

export const getLDFlag = (featureKey: string, defaultValue: boolean) => {
  if (!client && process.env.JEST_WORKER_ID) {
    return defaultValue;
  }
  if (!(featureKey in flagCache)) {
    flagCache[featureKey] = client.variation(featureKey, defaultValue);
  }
  return flagCache[featureKey];
};
